<template lang="html">
<div class="game-cell">
  <p class="game-name">{{cellData.name}}</p>
  <p class="game-players">
    <span
      v-for="(player, indexPlayer) in cellData.players"
      :class="{'winner': indexPlayer === cellData.winnerID}"
    >{{player.name}}</span>
  </p>
</div>
</template>

<script>
import TableCell from '../view/table/TableCell'

export default {
  name: 'GameCell',
  mixins: [ TableCell ],
}
</script>

<style lang="stylus">
@import '../styles/common'

.game-cell
  cursor pointer
  margin 1.5em 0

  .game-name
    font-size 1.4em
    margin 0

  .game-players
    font-size 1em
    margin 0
    span
      margin-right 5px

  .winner
    background-color black
    color white
    border-radius 3px
    padding 0.1em 0.4em
</style>



// WEBPACK FOOTER //
// GameCell.vue?263736a7